
import { createAsyncAction } from 'redux-promise-middleware-actions'
import { fetchOpenApiDefinition as fetchOpenApiDefinitionService } from '../../../services/esserver/openapi'

export const fetchOpenApiDefinition = createAsyncAction('FETCH_OPENAPI_DEFINITION', () => {
  return fetchOpenApiDefinitionService()
})
